var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _g8, _path9, _g9, _path10, _g10, _path11, _g11, _path12, _g12, _path13, _g13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsolidadoTres(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 132,
    viewBox: "0 0 120 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3191_33572",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 114,
    width: 10,
    height: 9
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.6363 114.989C61.3806 116.285 64.0716 120.944 64.2148 121.187C62.9265 121.931 61.4952 122.296 60.0638 122.296C58.6324 122.296 57.201 121.924 55.9199 121.187C56.0631 120.944 58.7541 116.285 59.4984 114.989C59.6701 115.089 59.8634 115.14 60.0638 115.14C60.2642 115.14 60.4574 115.089 60.6363 114.989Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3191_33572)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.6363 114.99C61.3806 116.286 64.0716 120.945 64.2148 121.188C62.9265 121.932 61.4952 122.297 60.0638 122.297C58.6324 122.297 57.201 121.925 55.9199 121.188C56.0631 120.945 58.7541 116.286 59.4984 114.99C59.6701 115.09 59.8634 115.141 60.0638 115.141C60.2642 115.141 60.4574 115.09 60.6363 114.99Z",
    fill: "#DDAFA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5055 114.99C59.6772 115.09 59.8705 115.141 60.0709 115.141C60.2712 115.141 60.4645 115.09 60.6434 114.99C61.3519 116.221 63.8211 120.494 64.1861 121.124C64.1503 121.167 64.1002 121.217 64.0644 121.26L63.9928 121.317C62.769 121.975 61.4164 122.305 60.0709 122.305C58.6395 122.305 57.2081 121.932 55.927 121.195C56.0701 120.952 58.7611 116.293 59.5055 114.997",
    fill: "#DDAFA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5055 114.99C59.6772 115.09 59.8705 115.141 60.0709 115.141C60.2712 115.141 60.4645 115.09 60.6434 114.99C61.2517 116.049 63.1698 119.363 63.9213 120.666C63.8926 120.723 63.8569 120.802 63.8211 120.866C63.6994 121.081 63.4775 121.482 63.0195 121.761C62.0676 122.119 61.0728 122.305 60.0709 122.305C58.6395 122.305 57.2081 121.932 55.927 121.195C56.0701 120.952 58.7611 116.293 59.5055 114.997",
    fill: "#DAADA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5055 114.991C59.6772 115.091 59.8705 115.141 60.0709 115.141C60.2712 115.141 60.4645 115.091 60.6434 114.991C61.1802 115.914 62.7046 118.562 63.5849 120.079C63.5634 120.144 63.5348 120.237 63.5133 120.301C63.4346 120.523 62.9837 121.661 61.8959 122.09C61.2947 122.226 60.6792 122.291 60.0709 122.291C58.6395 122.291 57.2081 121.918 55.927 121.181C56.0701 120.938 58.7611 116.279 59.5055 114.983",
    fill: "#D7AAA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5056 114.99C59.6774 115.09 59.8706 115.141 60.071 115.141C60.2714 115.141 60.4647 115.09 60.6436 114.99C61.1159 115.806 62.3541 117.946 63.2415 119.485C63.2272 119.535 63.2129 119.599 63.1986 119.649C62.8622 120.988 61.7601 122.09 60.5863 122.283C60.4146 122.29 60.2428 122.297 60.0782 122.297C58.6468 122.297 57.2154 121.925 55.9343 121.188C56.0775 120.945 58.7685 116.286 59.5128 114.99",
    fill: "#D4A89F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5055 114.99C59.6772 115.09 59.8705 115.141 60.0709 115.141C60.2712 115.141 60.4645 115.09 60.6434 114.99C61.0585 115.706 62.0605 117.452 62.905 118.905C62.8907 118.969 62.8692 119.048 62.8549 119.113C62.4541 120.959 60.7579 122.326 58.983 122.226C57.9238 122.083 56.8789 121.739 55.927 121.188C56.0701 120.945 58.7611 116.286 59.5055 114.99Z",
    fill: "#D1A69D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5056 114.99C59.6774 115.09 59.8706 115.141 60.071 115.141C60.2714 115.141 60.4647 115.09 60.6436 114.99C61.0086 115.62 61.8245 117.037 62.5903 118.361C62.5759 118.418 62.5616 118.49 62.5545 118.547C62.1465 120.837 59.7132 122.677 56.8719 121.66C56.5498 121.525 56.2349 121.367 55.9343 121.195C56.0775 120.952 58.7685 116.293 59.5128 114.997",
    fill: "#CEA49B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5056 114.991C59.6774 115.091 59.8706 115.141 60.071 115.141C60.2714 115.141 60.4646 115.091 60.6436 114.991C60.9585 115.534 61.6169 116.68 62.2896 117.839C62.2896 117.86 62.2825 117.896 62.2753 117.918C61.8316 120.795 58.7327 122.326 56.0273 121.01C56.5498 120.108 58.8329 116.157 59.5056 114.983",
    fill: "#CCA198"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5056 114.991C59.6774 115.091 59.8706 115.141 60.071 115.141C60.2714 115.141 60.4646 115.091 60.6435 114.991C60.9155 115.463 61.4451 116.372 62.0105 117.359C62.0105 117.41 61.9962 117.474 61.989 117.524C61.6097 119.893 59.0762 121.718 56.2563 120.609C57.0293 119.27 58.9044 116.028 59.5056 114.983",
    fill: "#C99F96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5055 114.99C59.6773 115.09 59.8705 115.141 60.0709 115.141C60.2713 115.141 60.4646 115.09 60.6435 114.99C60.8725 115.391 61.2876 116.1 61.7528 116.908C61.7528 116.951 61.7385 117.008 61.7313 117.051C61.352 119.47 58.933 120.888 56.5569 120.093C57.4372 118.576 58.9688 115.913 59.5055 114.99Z",
    fill: "#C69D94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5056 114.99C59.6774 115.09 59.8706 115.141 60.071 115.141C60.2714 115.141 60.4646 115.09 60.6435 114.99C60.8296 115.312 61.1445 115.856 61.5024 116.479C61.5024 116.515 61.488 116.565 61.488 116.608C61.1517 118.826 59.0475 120.158 56.8933 119.513C57.7879 117.975 59.0332 115.813 59.5056 114.99Z",
    fill: "#C39A92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5056 114.99C59.6773 115.09 59.8706 115.141 60.071 115.141C60.2714 115.141 60.4646 115.09 60.6435 114.99C60.7867 115.241 61.0085 115.62 61.2662 116.071C61.2662 116.1 61.259 116.143 61.2519 116.178C60.9727 118.168 59.2193 119.356 57.2583 118.876C58.0957 117.424 59.0905 115.699 59.5056 114.99Z",
    fill: "#C09890"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5056 114.991C59.6774 115.091 59.8706 115.141 60.071 115.141C60.2714 115.141 60.4646 115.091 60.6435 114.991C60.7437 115.162 60.8797 115.398 61.0372 115.67C61.0372 115.692 61.0372 115.728 61.03 115.749C60.9012 116.393 60.758 117.116 59.8491 117.775C58.9831 118.404 58.0241 118.247 57.6663 118.183C58.4034 116.909 59.1692 115.585 59.5127 114.983",
    fill: "#BD968E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5055 114.991C59.6773 115.091 59.8705 115.141 60.0709 115.141C60.2713 115.141 60.4646 115.091 60.6435 114.991C60.6864 115.069 60.7437 115.162 60.8009 115.263C60.8009 115.277 60.7938 115.305 60.7866 115.32C60.6506 115.971 60.5505 116.443 59.8634 116.98C59.2551 117.453 58.5895 117.431 58.1028 117.41C58.6825 116.4 59.2264 115.463 59.5055 114.983",
    fill: "#BA948C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3191_33572",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 88,
    width: 50,
    height: 34
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5054 114.99C58.7611 116.285 56.0629 120.945 55.9269 121.188L10.1584 94.7575C10.3016 94.5141 12.9926 89.855 13.7369 88.5596L59.5125 114.99H59.5054Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3191_33572)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7299 88.5596L59.5055 114.99C59.2264 115.47 58.6825 116.407 58.1028 117.416L12.3271 90.9858C12.9069 89.9766 13.4508 89.0391 13.7299 88.5596Z",
    fill: "#BA948C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3271 90.9854L58.1027 117.416C57.9524 117.673 57.8021 117.931 57.6518 118.189L11.8762 91.7583C12.0265 91.5007 12.1768 91.2358 12.3271 90.9854Z",
    fill: "#BD968E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8834 91.7666L57.659 118.197C57.523 118.426 57.3942 118.655 57.2654 118.884L11.4897 92.4537C11.6186 92.2318 11.7546 92.0028 11.8834 91.7666Z",
    fill: "#C09890"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4826 92.4453L57.2582 118.876C57.1294 119.098 57.0077 119.305 56.8932 119.513L11.1248 93.0823C11.2393 92.8819 11.3681 92.6672 11.4898 92.4453",
    fill: "#C39A92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1176 93.083L56.8861 119.514C56.7644 119.721 56.6499 119.921 56.5497 120.1L10.7812 93.6699C10.8886 93.491 10.996 93.2906 11.1176 93.083Z",
    fill: "#C69D94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7811 93.6699L56.5495 120.1C56.4422 120.294 56.342 120.465 56.2489 120.616L10.4805 94.1852C10.5664 94.0349 10.6665 93.8632 10.7811 93.6699Z",
    fill: "#C99F96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4805 94.1855L56.249 120.616C56.1559 120.781 56.0772 120.917 56.0199 121.017L10.2515 94.5863C10.3087 94.4861 10.3874 94.3502 10.4805 94.1855Z",
    fill: "#CCA198"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2516 94.5859L56.02 121.016C55.9699 121.109 55.9342 121.167 55.9198 121.188L10.1514 94.7577C10.1514 94.7577 10.2015 94.6718 10.2516 94.5859Z",
    fill: "#CEA49B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_3191_33572",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 88,
    width: 50,
    height: 34
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M106.412 88.5596C107.156 89.855 109.847 94.5141 109.983 94.7575L64.2147 121.188C64.0715 120.945 61.3805 116.285 60.6362 114.99L106.412 88.5596Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_3191_33572)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.6362 114.99L106.412 88.5596C106.455 88.6383 106.512 88.7313 106.569 88.8315L60.7937 115.262C60.7364 115.162 60.6792 115.069 60.6362 114.99Z",
    fill: "#BA948C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8008 115.262L106.576 88.8311C106.648 88.9527 106.727 89.0887 106.813 89.2318L61.037 115.662C60.9511 115.512 60.8724 115.376 60.8008 115.262Z",
    fill: "#BD968E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.03 115.671L106.806 89.2402C106.877 89.3691 106.956 89.4979 107.035 89.641L61.2591 116.072C61.1803 115.928 61.1016 115.8 61.03 115.671Z",
    fill: "#C09890"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.259 116.071L107.035 89.6406C107.113 89.7694 107.192 89.9054 107.271 90.0486L61.4952 116.479C61.4165 116.336 61.3378 116.2 61.259 116.071Z",
    fill: "#C39A92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4951 116.479L107.271 90.0488C107.349 90.1848 107.435 90.3279 107.514 90.4782L61.7384 116.909C61.6526 116.766 61.5738 116.622 61.4951 116.479Z",
    fill: "#C69D94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7456 116.908L107.521 90.4775C107.607 90.6278 107.693 90.7781 107.779 90.9284L62.0033 117.359C61.9174 117.209 61.8243 117.058 61.7456 116.908Z",
    fill: "#C99F96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0032 117.359L107.779 90.9287C107.872 91.0862 107.965 91.2508 108.058 91.4082L62.2823 117.839C62.1893 117.674 62.0962 117.517 62.0032 117.359Z",
    fill: "#CCA198"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2825 117.839L108.058 91.4082C108.158 91.58 108.258 91.7517 108.352 91.9235L62.5759 118.354C62.4757 118.182 62.3755 118.01 62.2825 117.839Z",
    fill: "#CEA49B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.583 118.354L108.359 91.9238C108.466 92.1099 108.573 92.2888 108.674 92.4677L62.8979 118.898C62.7977 118.719 62.6904 118.533 62.583 118.354Z",
    fill: "#D1A69D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8977 118.897L108.673 92.4668C108.788 92.6672 108.902 92.8604 109.01 93.0537L63.2341 119.484C63.1267 119.298 63.0122 119.105 62.8977 118.897Z",
    fill: "#D4A89F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2344 119.485L109.01 93.0547C109.132 93.2694 109.246 93.4698 109.354 93.6559L63.5779 120.086C63.4706 119.9 63.356 119.7 63.2344 119.485Z",
    fill: "#D7AAA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5779 120.079L109.354 93.6484C109.482 93.8631 109.59 94.0635 109.69 94.2281L63.9214 120.659C63.8284 120.494 63.7139 120.301 63.585 120.079",
    fill: "#DAADA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9141 120.658L109.683 94.2275C109.804 94.4351 109.89 94.5925 109.94 94.6784L64.1718 121.109C64.1217 121.016 64.0286 120.866 63.907 120.658",
    fill: "#DDAFA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1716 121.109L109.94 94.6787L109.983 94.7574L64.2146 121.188L64.1716 121.109Z",
    fill: "#E0B1A7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_3191_33572",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 87,
    width: 8,
    height: 8
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7297 88.5596C12.9854 89.855 10.2944 94.5141 10.1513 94.7575C7.58192 93.276 6.00024 90.5349 6.00024 87.5791C6.28652 87.5791 11.6614 87.5791 13.1572 87.5791C13.1572 87.987 13.3719 88.352 13.7297 88.5596Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_3191_33572)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7297 88.5596C12.9854 89.855 10.2944 94.5141 10.1513 94.7575C7.58192 93.276 6.00024 90.5349 6.00024 87.5791C6.28652 87.5791 11.6614 87.5791 13.1572 87.5791C13.1572 87.987 13.3719 88.352 13.7297 88.5596Z",
    fill: "#CEA49B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1571 87.5794C13.1571 87.9874 13.3718 88.3524 13.7296 88.5599C12.9853 89.8553 10.2943 94.5145 10.1512 94.7578C8.14722 93.5984 6.74446 91.6803 6.22201 89.476C6.2077 89.4044 6.19338 89.3042 6.18622 89.2327C6.12897 88.4597 6.15044 88.245 6.27926 87.5723C7.44584 87.5723 11.833 87.5723 13.1642 87.5723",
    fill: "#CEA49B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1571 87.5794C13.1571 87.9874 13.3718 88.3524 13.7297 88.5599C13.0498 89.7337 10.7739 93.6771 10.2514 94.5789C10.1369 94.5216 9.98662 94.4501 9.87927 94.4C6.93778 92.6895 6.09326 89.6692 6.78032 87.5723C8.38347 87.5723 11.9834 87.5723 13.1643 87.5723",
    fill: "#CCA198"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1572 87.5794C13.1572 87.9874 13.3719 88.3524 13.7297 88.5599C13.1286 89.6048 11.2534 92.8398 10.4877 94.1781C10.4662 94.1709 10.4304 94.1566 10.4089 94.1423C8.12587 93.1475 6.2937 90.5066 7.38871 87.5723C9.16362 87.5723 12.1194 87.5723 13.1643 87.5723",
    fill: "#C99F96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1572 87.5791C13.1572 87.987 13.3719 88.352 13.7297 88.5596C13.193 89.49 11.6614 92.1452 10.7811 93.6625C10.6809 93.6195 10.5449 93.5694 10.4375 93.5337C8.05429 92.3742 7.02369 89.8192 8.04713 87.5791C9.82205 87.5791 12.2339 87.5791 13.1572 87.5791Z",
    fill: "#C69D94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1572 87.5791C13.1572 87.987 13.3719 88.352 13.7297 88.5596C13.2574 89.3755 12.0121 91.5369 11.1175 93.0828C11.0244 93.047 10.8956 93.004 10.8026 92.9683C8.34774 91.8518 7.82529 89.354 8.74138 87.5791C10.4018 87.5791 12.3485 87.5791 13.1572 87.5791Z",
    fill: "#C39A92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1572 87.5791C13.1572 87.987 13.3719 88.352 13.7297 88.5596C13.3218 89.2681 12.327 90.9929 11.4896 92.4458C11.4037 92.4172 11.2964 92.3814 11.2105 92.3528C9.22085 91.5082 8.46938 89.4542 9.46419 87.5791C10.9385 87.5791 12.4701 87.5791 13.1643 87.5791",
    fill: "#C09890"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1571 87.5794C13.1571 87.9874 13.3718 88.3524 13.7297 88.5599C13.3861 89.1611 12.6132 90.4851 11.8832 91.7591C11.8116 91.7376 11.7114 91.7018 11.6399 91.6803C10.1441 91.1006 9.16356 89.4975 10.2013 87.5723C11.4251 87.5723 12.5846 87.5723 13.1571 87.5723",
    fill: "#BD968E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1572 87.5794C13.1572 87.9874 13.372 88.3524 13.7298 88.5599C13.4507 89.0394 12.9068 89.977 12.327 90.9861C12.2698 90.9646 12.1911 90.9432 12.1267 90.9217C12.1052 90.9145 9.68614 90.0414 11.0173 87.5723C11.9191 87.5723 12.7135 87.5723 13.1572 87.5723",
    fill: "#BA948C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_3191_33572",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 106,
    y: 87,
    width: 9,
    height: 8
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M106.977 87.5791C108.473 87.5791 113.848 87.5791 114.134 87.5791C114.134 90.5421 112.56 93.276 109.983 94.7575C109.84 94.5141 107.156 89.8478 106.412 88.5596C106.763 88.352 106.977 87.987 106.977 87.5791Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_3191_33572)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.977 87.5791C108.473 87.5791 113.848 87.5791 114.134 87.5791C114.134 90.5421 112.56 93.276 109.983 94.7575C109.84 94.5141 107.156 89.8478 106.412 88.5596C106.763 88.352 106.977 87.987 106.977 87.5791Z",
    fill: "#F6C3B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.412 88.5596C106.763 88.352 106.977 87.987 106.977 87.5791C108.194 87.5791 111.98 87.5791 113.504 87.5791C113.998 87.7723 114.027 87.7795 114.127 87.8296C114.041 90.6924 112.481 93.3189 109.983 94.7575C109.84 94.5141 107.156 89.8478 106.412 88.5596Z",
    fill: "#F6C3B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.412 88.5596C106.763 88.352 106.977 87.987 106.977 87.5791C107.858 87.5791 110.091 87.5791 111.83 87.5791C113.676 88.5453 113.919 88.8101 114.027 88.9246C113.626 91.3508 112.166 93.505 109.99 94.7646C109.847 94.5213 107.163 89.855 106.419 88.5668",
    fill: "#F4C1B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.412 88.5596C106.763 88.352 106.977 87.987 106.977 87.5791C107.693 87.5791 109.303 87.5791 110.821 87.5791C112.08 88.3019 113.512 89.3325 113.805 89.9051C113.218 91.9305 111.865 93.6768 109.99 94.7646C109.847 94.5213 107.163 89.855 106.419 88.5668",
    fill: "#F1BFB4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.412 88.5596C106.763 88.352 106.977 87.987 106.977 87.5791C107.578 87.5791 108.817 87.5791 110.091 87.5791C112.195 88.9246 113.325 90.1914 113.483 90.7997C112.789 92.4386 111.579 93.8414 109.983 94.7575C109.84 94.5141 107.156 89.8478 106.412 88.5596Z",
    fill: "#EEBCB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.412 88.5596C106.763 88.352 106.977 87.987 106.977 87.5791C107.485 87.5791 108.459 87.5791 109.518 87.5791C111.422 88.8172 113.018 90.6351 113.075 91.6299C112.359 92.911 111.3 93.9988 109.983 94.7575C109.84 94.5141 107.156 89.8478 106.412 88.5596Z",
    fill: "#EBBAB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.412 88.5596C106.763 88.352 106.977 87.987 106.977 87.5791C107.414 87.5791 108.18 87.5791 109.053 87.5791C111.543 89.2395 112.839 91.7015 112.595 92.4029C111.916 93.3476 111.035 94.1635 109.99 94.7646C109.847 94.5213 107.163 89.855 106.419 88.5668",
    fill: "#E8B8AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.412 88.5596C106.763 88.352 106.977 87.987 106.977 87.5791C107.342 87.5791 107.951 87.5791 108.659 87.5791C111.307 89.4041 112.438 92.3027 112.023 93.1114C111.443 93.7555 110.763 94.3138 109.99 94.7575C109.847 94.5141 107.163 89.8478 106.419 88.5596",
    fill: "#E5B6AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.412 88.5596C106.763 88.352 106.977 87.987 106.977 87.5791C107.285 87.5791 107.757 87.5791 108.323 87.5791C111.164 89.6188 112.009 92.8609 111.364 93.7698C110.942 94.142 110.484 94.4784 109.99 94.7646C109.847 94.5213 107.163 89.855 106.419 88.5668",
    fill: "#E2B3AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.412 88.5596C106.763 88.352 106.977 87.987 106.977 87.5791C107.228 87.5791 107.593 87.5791 108.029 87.5791C110.828 89.6689 111.593 93.1758 110.613 94.3567C110.413 94.4998 110.198 94.6358 109.983 94.7575C109.84 94.5141 107.156 89.8478 106.412 88.5596Z",
    fill: "#E0B1A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.412 88.5596C106.763 88.352 106.977 87.987 106.977 87.5791C107.178 87.5791 107.45 87.5791 107.772 87.5791C110.613 89.7262 111.05 93.369 109.94 94.6859C109.561 94.0275 107.113 89.7834 106.412 88.5596Z",
    fill: "#DDAFA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.412 88.5596C106.763 88.352 106.977 87.987 106.977 87.5791C107.128 87.5791 107.321 87.5791 107.543 87.5791C109.632 89.1751 110.57 92.0951 109.683 94.235C108.931 92.9253 107.02 89.6188 106.412 88.5668",
    fill: "#DAADA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.412 88.5596C106.763 88.352 106.977 87.987 106.977 87.5791C107.085 87.5791 107.206 87.5791 107.342 87.5791C109.182 89.0534 109.983 91.4939 109.346 93.6553C108.466 92.1309 106.941 89.49 106.412 88.5596Z",
    fill: "#D7AAA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.412 88.5596C106.763 88.352 106.977 87.987 106.977 87.5791C107.035 87.5791 107.099 87.5791 107.17 87.5791C108.788 88.9246 109.475 90.9715 109.003 93.0541C108.115 91.5154 106.877 89.3683 106.412 88.5596Z",
    fill: "#D4A89F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.412 88.5596C106.763 88.352 106.977 87.987 106.977 87.5791H107.013C108.444 88.8602 109.003 90.5063 108.666 92.4744C107.829 91.0144 106.82 89.2753 106.412 88.5596Z",
    fill: "#D1A69D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.412 88.5597C106.741 88.3664 106.941 88.0372 106.977 87.665C106.984 87.6722 106.999 87.6865 107.006 87.6937C108.158 88.8316 108.609 90.2487 108.351 91.9234C107.593 90.5994 106.77 89.1823 106.412 88.5597Z",
    fill: "#CEA49B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.412 88.5594C106.706 88.3876 106.899 88.1085 106.956 87.7793C106.963 87.7865 106.978 87.8008 106.985 87.8151C108.194 89.1534 108.173 90.6421 108.051 91.4079C107.385 90.2484 106.72 89.1033 106.412 88.5594Z",
    fill: "#CCA198"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.412 88.5601C106.67 88.4098 106.856 88.1737 106.935 87.8945C106.942 87.9088 106.956 87.9232 106.963 87.9303C107.65 88.8106 107.922 89.8197 107.779 90.9291C107.214 89.9414 106.684 89.0325 106.412 88.5601Z",
    fill: "#C99F96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.412 88.5595C106.641 88.4307 106.806 88.2303 106.899 87.9941C106.906 88.0085 106.92 88.0228 106.927 88.0299C107.421 88.7814 107.593 89.4899 107.521 90.4704C107.056 89.6617 106.648 88.9532 106.419 88.5524",
    fill: "#C69D94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.412 88.5596C106.605 88.4451 106.756 88.2876 106.849 88.1016C106.849 88.1087 106.863 88.123 106.87 88.1373C107.207 88.7672 107.321 89.3039 107.271 90.0482C106.913 89.4256 106.598 88.8888 106.412 88.5596Z",
    fill: "#C39A92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.412 88.5597C106.562 88.4738 106.691 88.3521 106.784 88.209C106.784 88.209 106.784 88.209 106.784 88.2161C106.927 88.574 107.063 88.9748 107.027 89.6332C106.77 89.1823 106.548 88.803 106.405 88.5525",
    fill: "#C09890"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.412 88.5601C106.519 88.4957 106.612 88.4169 106.698 88.3311C106.698 88.3454 106.705 88.3668 106.712 88.3812C106.777 88.6603 106.82 88.8965 106.805 89.2471C106.648 88.9752 106.512 88.739 106.412 88.5672",
    fill: "#BD968E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.412 88.5602C106.462 88.5315 106.512 88.4957 106.562 88.46C106.562 88.46 106.562 88.4671 106.562 88.4743C106.562 88.5959 106.57 88.7176 106.57 88.8321C106.512 88.7319 106.462 88.6389 106.412 88.5602Z",
    fill: "#BA948C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_3191_33572",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 106,
    y: 34,
    width: 9,
    height: 54
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M106.977 34.7178C108.473 34.7178 113.848 34.7178 114.134 34.7178V87.5716C113.848 87.5716 108.473 87.5716 106.977 87.5716V34.7178Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_3191_33572)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.977 87.5787V34.7178H107.013V87.5716H106.977",
    fill: "#D1A69D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.013 87.5787V34.7178C107.063 34.7178 107.113 34.7178 107.163 34.7178V87.5716C107.106 87.5716 107.056 87.5716 107.013 87.5716",
    fill: "#D4A89F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.17 87.5787V34.7178C107.227 34.7178 107.285 34.7178 107.349 34.7178V87.5716C107.285 87.5716 107.227 87.5716 107.17 87.5716",
    fill: "#D7AAA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.342 87.5787V34.7178C107.406 34.7178 107.471 34.7178 107.542 34.7178V87.5716C107.471 87.5716 107.406 87.5716 107.342 87.5716",
    fill: "#DAADA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.542 87.5787V34.7178C107.614 34.7178 107.693 34.7178 107.772 34.7178V87.5716C107.693 87.5716 107.614 87.5716 107.542 87.5716",
    fill: "#DDAFA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.771 87.5787V34.7178C107.857 34.7178 107.943 34.7178 108.029 34.7178V87.5716C107.943 87.5716 107.857 87.5716 107.771 87.5716",
    fill: "#E0B1A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.029 87.5787V34.7178C108.122 34.7178 108.222 34.7178 108.322 34.7178V87.5716C108.222 87.5716 108.129 87.5716 108.029 87.5716",
    fill: "#E2B3AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.315 87.5787V34.7178C108.423 34.7178 108.537 34.7178 108.652 34.7178V87.5716C108.537 87.5716 108.423 87.5716 108.315 87.5716",
    fill: "#E5B6AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.652 87.5787V34.7178C108.781 34.7178 108.91 34.7178 109.045 34.7178V87.5716C108.91 87.5716 108.781 87.5716 108.652 87.5716",
    fill: "#E8B8AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.052 87.5787V34.7178C109.203 34.7178 109.36 34.7178 109.518 34.7178V87.5716C109.36 87.5716 109.203 87.5716 109.052 87.5716",
    fill: "#EBBAB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.518 87.5787V34.7178C109.704 34.7178 109.897 34.7178 110.083 34.7178V87.5716C109.89 87.5716 109.704 87.5716 109.518 87.5716",
    fill: "#EEBCB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.083 87.5787V34.7178C110.327 34.7178 110.577 34.7178 110.82 34.7178V87.5716C110.577 87.5716 110.327 87.5716 110.083 87.5716",
    fill: "#F1BFB4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.827 87.5787V34.7178C111.171 34.7178 111.507 34.7178 111.829 34.7178V87.5716C111.507 87.5716 111.171 87.5716 110.827 87.5716",
    fill: "#F4C1B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.829 87.5787V34.7178C112.495 34.7178 113.089 34.7178 113.511 34.7178V87.5716C113.089 87.5716 112.495 87.5716 111.829 87.5716",
    fill: "#F6C3B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.511 87.5787V34.7178C113.855 34.7178 114.084 34.7178 114.134 34.7178V87.5716C114.084 87.5716 113.855 87.5716 113.511 87.5716",
    fill: "#F9C5BB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_3191_33572",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 34,
    width: 8,
    height: 54
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1572 87.5787C11.6614 87.5787 6.28652 87.5787 6.00024 87.5787V34.7178C6.28652 34.7178 11.6614 34.7178 13.1572 34.7178V87.5716V87.5787Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_3191_33572)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.157 34.7178V87.5716C12.7133 87.5716 11.9189 87.5716 11.0171 87.5716V34.7178C11.9189 34.7178 12.7133 34.7178 13.157 34.7178Z",
    fill: "#BA948C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0171 34.7178V87.5716C10.7523 87.5716 10.4803 87.5716 10.2012 87.5716V34.7178C10.4803 34.7178 10.7523 34.7178 11.0171 34.7178Z",
    fill: "#BD968E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2014 34.7178V87.5716C9.95086 87.5716 9.70752 87.5716 9.45703 87.5716V34.7178C9.70752 34.7178 9.95802 34.7178 10.2014 34.7178Z",
    fill: "#C09890"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.4569 34.7178V87.5716C9.21357 87.5716 8.97739 87.5716 8.74121 87.5716V34.7178C8.97739 34.7178 9.21357 34.7178 9.4569 34.7178Z",
    fill: "#C39A92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.74134 34.7178V87.5716C8.50516 87.5716 8.26898 87.5716 8.04712 87.5716V34.7178C8.26898 34.7178 8.50516 34.7178 8.74134 34.7178Z",
    fill: "#C69D94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.04694 34.7178V87.5716C7.81076 87.5716 7.5889 87.5716 7.38135 87.5716V34.7178C7.5889 34.7178 7.81076 34.7178 8.04694 34.7178Z",
    fill: "#C99F96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.38861 34.7178V87.5716C7.16675 87.5716 6.9592 87.5716 6.78027 87.5716V34.7178C6.9592 34.7178 7.16675 34.7178 7.38861 34.7178Z",
    fill: "#CCA198"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.7732 34.7178V87.5716C6.57281 87.5716 6.40104 87.5716 6.27222 87.5716V34.7178C6.40104 34.7178 6.57281 34.7178 6.7732 34.7178Z",
    fill: "#CEA49B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27929 34.7178V87.5716C6.12899 87.5716 6.03595 87.5716 6.00732 87.5716V34.7178C6.00732 34.7178 6.13615 34.7178 6.27929 34.7178Z",
    fill: "#D1A69D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_3191_33572",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 27,
    width: 8,
    height: 8
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1572 34.7178C11.6614 34.7178 6.28652 34.7178 6.00024 34.7178C6.00024 31.7548 7.58192 29.0137 10.1513 27.5322C10.2944 27.7756 12.9782 32.4419 13.7226 33.7301C13.3719 33.9377 13.1572 34.3027 13.1572 34.7106V34.7178Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_3191_33572)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1572 34.7178C11.6614 34.7178 6.28652 34.7178 6.00024 34.7178C6.00024 31.7548 7.58192 29.0137 10.1513 27.5322C10.2944 27.7756 12.9782 32.4419 13.7226 33.7301C13.3719 33.9377 13.1572 34.3027 13.1572 34.7106",
    fill: "#E5B6AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7226 33.7371C13.3719 33.9446 13.1572 34.3096 13.1572 34.7175C11.6614 34.7175 6.28652 34.7175 6.00024 34.7175C6.00024 31.8691 7.46026 29.2282 9.85066 27.7109C9.96518 27.6966 10.1298 27.6966 10.2443 27.7109C10.7596 28.6127 13.0426 32.5633 13.7154 33.7371",
    fill: "#E5B6AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7226 33.7368C13.3719 33.9444 13.1572 34.3094 13.1572 34.7173C11.6614 34.7173 6.28652 34.7173 6.00024 34.7173C6.00024 32.1838 7.15251 29.8148 9.09919 28.2546C9.6789 28.09 10.1226 28.2045 10.6308 28.3763C11.4681 29.8363 13.1572 32.7563 13.7226 33.7368Z",
    fill: "#E2B3AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7226 33.7373C13.3719 33.9449 13.1572 34.3099 13.1572 34.7178C11.6614 34.7178 6.28652 34.7178 6.00024 34.7178C6.00024 32.5064 6.88054 30.4237 8.39065 28.8921C9.33537 28.3911 10.5735 28.8921 11.0387 29.0782C11.9333 30.6241 13.2359 32.8928 13.7226 33.7302",
    fill: "#E0B1A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7226 33.7371C13.3719 33.9446 13.1572 34.3096 13.1572 34.7176C11.6614 34.7176 6.28652 34.7176 6.00024 34.7176C6.00024 32.8496 6.6229 31.0747 7.73222 29.6433C8.62683 29.0207 9.87214 29.0565 11.418 29.7364C12.2697 31.2107 13.3003 33.0071 13.7226 33.7371Z",
    fill: "#DDAFA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7226 33.7375C13.3719 33.945 13.1572 34.31 13.1572 34.718C11.6614 34.718 6.28652 34.718 6.00024 34.718C6.00024 33.2222 6.40103 31.7836 7.13104 30.5312C8.06859 29.522 9.97233 29.4362 11.7544 30.3236C12.5274 31.662 13.3576 33.1005 13.7226 33.7375Z",
    fill: "#DAADA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7226 33.7372C13.3719 33.9447 13.1572 34.3097 13.1572 34.7177C11.6614 34.7177 6.28652 34.7177 6.00024 34.7177C6.00024 33.6227 6.21495 32.5635 6.61574 31.583C7.24555 30.5452 9.22086 29.4931 12.0622 30.853C12.7349 32.0267 13.4077 33.1861 13.7226 33.7372Z",
    fill: "#D7AAA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7226 33.7377C13.3719 33.9452 13.1572 34.3102 13.1572 34.7182C11.6614 34.7182 6.28652 34.7182 6.00024 34.7182C6.00024 34.0812 6.07181 33.4514 6.21495 32.843C6.95927 30.9894 9.44988 29.9159 12.327 31.3115C12.9067 32.3134 13.4506 33.2581 13.7226 33.7305",
    fill: "#D4A89F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7226 33.7371C13.3719 33.9446 13.1572 34.3096 13.1572 34.7176C11.6614 34.7176 6.28652 34.7176 6.00024 34.7176C6.00024 34.6174 6.00024 34.5243 6.00024 34.4241C6.34378 31.8548 9.29242 30.1157 12.5631 31.726C13.0498 32.5705 13.4792 33.3148 13.7154 33.7299",
    fill: "#D1A69D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7226 33.737C13.3719 33.9445 13.1572 34.3095 13.1572 34.7175C11.8331 34.7175 7.43879 34.7175 6.27222 34.7175C7.15967 31.5398 10.3445 30.8885 12.785 32.1123C13.1786 32.7994 13.5222 33.3863 13.7226 33.737Z",
    fill: "#CEA49B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7226 33.7365C13.3719 33.9441 13.1572 34.3091 13.1572 34.717C11.9763 34.717 8.37634 34.717 6.77319 34.717C7.88252 31.8901 10.8025 31.3461 12.9854 32.4555C13.2931 32.9922 13.5579 33.4503 13.7226 33.7365Z",
    fill: "#CCA198"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7226 33.7374C13.3719 33.945 13.1572 34.31 13.1572 34.7179C12.1123 34.7179 9.15651 34.7179 7.38159 34.7179C8.60542 32.1414 11.275 31.7907 13.1644 32.7712C13.3934 33.172 13.5866 33.5084 13.7226 33.7374Z",
    fill: "#C99F96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7226 33.7373C13.3719 33.9449 13.1572 34.3099 13.1572 34.7178C12.2339 34.7178 9.82203 34.7178 8.04712 34.7178C9.27095 32.4491 11.6327 32.1628 13.3289 33.0574C13.4864 33.3294 13.6224 33.5655 13.7226 33.7373Z",
    fill: "#C69D94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7227 33.7374C13.372 33.9449 13.1573 34.31 13.1573 34.7179C12.3485 34.7179 10.4019 34.7179 8.74146 34.7179C9.97244 32.6925 12.0623 32.578 13.4865 33.3223C13.5795 33.4798 13.6583 33.6229 13.7227 33.7374Z",
    fill: "#C39A92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7226 33.7372C13.3719 33.9448 13.1572 34.3098 13.1572 34.7177C12.4629 34.7177 10.9314 34.7177 9.45703 34.7177C10.6665 32.9213 12.4558 32.9714 13.6224 33.5654C13.6581 33.6299 13.6939 33.6871 13.7226 33.7372Z",
    fill: "#C09890"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1572 34.7172C12.5775 34.7172 11.4181 34.7172 10.2014 34.7172C11.0388 33.5435 12.3413 33.1785 13.694 33.7582C13.3576 33.9657 13.1644 34.3236 13.1572 34.7172Z",
    fill: "#BD968E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1572 34.7174C12.7134 34.7174 11.919 34.7174 11.0244 34.7174C11.7115 33.9015 12.5059 33.6296 13.5436 33.8729C13.3003 34.0876 13.1643 34.3882 13.1643 34.7174",
    fill: "#BA948C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_3191_33572",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 106,
    y: 27,
    width: 9,
    height: 8
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M106.412 33.7379C107.156 32.4425 109.847 27.7834 109.99 27.54C112.56 29.0215 114.141 31.7626 114.141 34.7256C113.855 34.7256 108.48 34.7256 106.984 34.7256C106.984 34.3176 106.77 33.9526 106.412 33.7451V33.7379Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_3191_33572)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.412 33.7379C107.156 32.4425 109.847 27.7834 109.99 27.54C112.56 29.0215 114.141 31.7626 114.141 34.7256C113.855 34.7256 108.48 34.7256 106.984 34.7256C106.984 34.3176 106.77 33.9526 106.412 33.7451",
    fill: "#FCC8BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.977 34.7183C106.977 34.3104 106.763 33.9454 106.405 33.7379C106.906 32.8719 108.273 30.5029 109.167 28.957V28.9713C109.217 30.3383 109.289 31.1399 110.169 31.7769C110.935 32.3279 113.118 32.6643 113.662 32.1991C113.683 32.1848 113.705 32.1562 113.719 32.1347C113.991 32.9577 114.134 33.8309 114.134 34.7183C113.848 34.7183 108.473 34.7183 106.977 34.7183Z",
    fill: "#FCC8BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.977 34.7182C106.977 34.3103 106.763 33.9453 106.405 33.7377C106.77 33.1008 107.607 31.6479 108.38 30.3096C108.394 30.3668 108.409 30.4456 108.423 30.51C108.767 31.6765 108.888 32.0702 109.776 32.5712C110.405 32.929 112.975 33.7234 114.07 33.7091C114.113 34.0383 114.134 34.3819 114.134 34.7182C113.848 34.7182 108.473 34.7182 106.977 34.7182Z",
    fill: "#F9C5BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.977 34.7187C106.977 34.3108 106.763 33.9458 106.405 33.7382C106.705 33.2229 107.314 32.1637 107.951 31.0615C107.972 31.1402 108.008 31.2404 108.037 31.3192C108.516 32.679 108.616 32.9581 113.504 34.7187C111.98 34.7187 108.194 34.7187 106.977 34.7187Z",
    fill: "#F6C3B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.977 34.7177C106.977 34.3098 106.763 33.9448 106.405 33.7373C106.655 33.3078 107.12 32.4991 107.636 31.6045C107.636 31.6045 107.636 31.6116 107.636 31.6188C107.965 32.3679 108.273 32.8474 108.559 33.0573C108.678 33.148 109.184 33.4128 110.076 33.8518C110.656 34.138 111.243 34.4172 111.823 34.7177C110.083 34.7177 107.85 34.7177 106.97 34.7177",
    fill: "#F4C1B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.977 34.718C106.977 34.3101 106.763 33.9451 106.405 33.7375C106.612 33.3725 106.977 32.7427 107.4 32.0127C107.421 32.0628 107.457 32.1344 107.478 32.1845C107.657 32.621 107.786 32.9359 108.215 33.2652C109.01 33.8735 109.947 34.2242 110.806 34.718C109.296 34.718 107.686 34.718 106.97 34.718",
    fill: "#F1BFB4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.977 34.7192C106.977 34.3113 106.763 33.9463 106.405 33.7387C106.584 33.431 106.87 32.9371 107.206 32.3574C107.228 32.4004 107.256 32.4576 107.278 32.5006C107.5 33.0015 107.607 33.1876 107.936 33.4453C108.595 33.9677 109.382 34.2755 110.083 34.7264C108.81 34.7264 107.579 34.7264 106.977 34.7264",
    fill: "#EEBCB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.977 34.7184C106.977 34.3105 106.763 33.9455 106.405 33.7379C106.555 33.4803 106.777 33.0938 107.042 32.6357C107.056 32.6644 107.07 32.7002 107.085 32.7359C107.335 33.2369 107.392 33.3514 107.686 33.5948C108.244 34.0528 108.91 34.3319 109.504 34.7256C108.445 34.7256 107.478 34.7256 106.97 34.7256",
    fill: "#EBBAB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.977 34.7186C106.977 34.3106 106.763 33.9456 106.405 33.7381C106.526 33.5305 106.698 33.2299 106.906 32.8721C107.171 33.4017 107.206 33.4804 107.485 33.7166C107.564 33.7882 107.621 33.8383 108.273 34.2176C108.497 34.3512 108.752 34.5182 109.039 34.7186C108.173 34.7186 107.407 34.7186 106.977 34.7186Z",
    fill: "#E8B8AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.977 34.7187C106.977 34.3107 106.763 33.9457 106.405 33.7382C106.498 33.5736 106.627 33.3517 106.784 33.0869C106.798 33.1155 106.82 33.1585 106.834 33.1871C106.999 33.5378 107.085 33.6595 107.299 33.8312C107.715 34.1819 108.208 34.4038 108.652 34.7187C107.951 34.7187 107.35 34.7187 106.977 34.7187Z",
    fill: "#E5B6AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.977 34.7182C106.977 34.3102 106.763 33.9452 106.405 33.7377C106.476 33.6088 106.569 33.4514 106.677 33.2725C106.677 33.2796 106.684 33.2868 106.691 33.2939C106.899 33.6804 106.934 33.7448 107.142 33.9309C107.5 34.2458 107.936 34.4462 108.316 34.7253C107.757 34.7253 107.285 34.7253 106.977 34.7253",
    fill: "#E2B3AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.977 34.7189C106.977 34.311 106.763 33.946 106.405 33.7384C106.455 33.6525 106.512 33.5452 106.584 33.4307C106.598 33.4521 106.612 33.4879 106.627 33.5094C106.72 33.6883 106.813 33.8529 106.999 34.0175C107.314 34.2895 107.693 34.4613 108.022 34.7261C107.593 34.7261 107.228 34.7261 106.977 34.7261",
    fill: "#E0B1A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.977 34.7183C106.977 34.3104 106.763 33.9454 106.405 33.7379C106.433 33.6878 106.469 33.6305 106.498 33.5732C106.512 33.5947 106.526 33.6233 106.534 33.6377C106.627 33.8094 106.705 33.9454 106.87 34.0885C107.142 34.3319 107.478 34.4893 107.75 34.7183C107.435 34.7183 107.163 34.7183 106.963 34.7183",
    fill: "#DDAFA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.977 34.7181C106.977 34.5463 106.941 34.3817 106.87 34.2314C106.884 34.2386 106.898 34.2529 106.913 34.2601C107.12 34.4104 107.335 34.5535 107.535 34.711C107.314 34.711 107.128 34.711 106.977 34.711",
    fill: "#DAADA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.977 34.7186C106.977 34.6112 106.963 34.511 106.934 34.418C106.934 34.418 106.949 34.4251 106.956 34.4323C107.085 34.5253 107.213 34.6184 107.335 34.7186C107.199 34.7186 107.077 34.7186 106.977 34.7186Z",
    fill: "#D7AAA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.977 34.718C106.977 34.6679 106.977 34.6106 106.963 34.5605C106.977 34.5749 106.999 34.5892 107.013 34.5963C107.056 34.6321 107.113 34.6822 107.156 34.718C107.092 34.718 107.028 34.718 106.97 34.718",
    fill: "#D4A89F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.412 33.7373L106.44 33.6943C106.44 33.6943 106.462 33.7373 106.476 33.7516L106.498 33.7874C106.498 33.7874 106.448 33.7516 106.419 33.7373",
    fill: "#DAADA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.977 34.7181C106.977 34.7181 106.977 34.6966 106.977 34.6895C106.984 34.6966 106.999 34.7109 107.006 34.7181C106.999 34.7181 106.984 34.7181 106.977 34.7181Z",
    fill: "#D1A69D"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_3191_33572",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 1,
    width: 50,
    height: 33
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6434 7.3141C61.3877 6.0187 64.0787 1.35955 64.2147 1.11621L109.983 27.5467C109.84 27.79 107.149 32.4492 106.405 33.7446L60.6362 7.32126L60.6434 7.3141Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_3191_33572)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.412 33.7381L60.6436 7.31475L60.6722 7.26465L106.441 33.688L106.412 33.7381Z",
    fill: "#DAADA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.441 33.6876L60.6721 7.26425C60.6936 7.22846 60.7151 7.18552 60.7437 7.14258L106.512 33.5659C106.491 33.6089 106.462 33.6518 106.441 33.6876Z",
    fill: "#DDAFA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.505 33.5665L60.7437 7.14314C60.7723 7.1002 60.7938 7.0501 60.8224 7L106.591 33.4233C106.562 33.4734 106.534 33.5164 106.512 33.5665",
    fill: "#E0B1A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.591 33.4297L60.8225 6.99925C60.8511 6.94915 60.8798 6.89905 60.9155 6.8418L106.684 33.2651C106.655 33.3224 106.62 33.3725 106.591 33.4226",
    fill: "#E2B3AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.684 33.2728L60.9155 6.84233C60.9513 6.78507 60.9871 6.72066 61.0229 6.65625L106.791 33.0796C106.756 33.144 106.72 33.2084 106.684 33.2657",
    fill: "#E5B6AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.791 33.0863L61.0229 6.65579C61.0587 6.59138 61.1017 6.51981 61.1446 6.44824L106.913 32.8716C106.87 32.9431 106.834 33.0147 106.791 33.0791",
    fill: "#E8B8AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.906 32.8714L61.1445 6.44809C61.1875 6.36937 61.2376 6.29064 61.2805 6.21191L107.049 32.6352C106.999 32.714 106.956 32.7999 106.913 32.8714",
    fill: "#EBBAB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.049 32.6364L61.2805 6.21303C61.3306 6.11999 61.3879 6.02695 61.4451 5.92676L107.214 32.3501C107.156 32.4503 107.099 32.5433 107.049 32.6364Z",
    fill: "#EEBCB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.214 32.3489L61.4451 5.91841C61.5095 5.81105 61.5739 5.69654 61.6383 5.58203L107.407 32.0054C107.342 32.1199 107.278 32.2344 107.214 32.3417",
    fill: "#F1BFB4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.407 32.0054L61.6384 5.58209C61.7172 5.44611 61.7959 5.31013 61.8746 5.16699L107.643 31.5903C107.564 31.7335 107.478 31.8694 107.407 32.0054Z",
    fill: "#F4C1B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.65 31.5913L61.8816 5.16796C61.9818 4.9962 62.082 4.81727 62.1822 4.64551L107.951 31.0688C107.85 31.2478 107.75 31.4195 107.65 31.5913Z",
    fill: "#F6C3B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.951 31.0684L62.1824 4.64503C62.3255 4.39454 62.4758 4.14405 62.6189 3.89355L108.387 30.324C108.244 30.5745 108.094 30.825 107.951 31.0755",
    fill: "#F9C5BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.387 30.317L62.6189 3.8865C62.898 3.39983 63.17 2.92748 63.4062 2.51953L109.175 28.95C108.938 29.3651 108.666 29.8303 108.387 30.317Z",
    fill: "#FCC8BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.174 28.9498L63.406 2.51929C63.8497 1.7535 64.1718 1.1881 64.2147 1.10938L109.983 27.5399C109.933 27.6186 109.611 28.184 109.167 28.9498",
    fill: "#FFCABF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_3191_33572",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 1,
    width: 50,
    height: 33
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7227 33.7378C12.9783 32.4423 10.2873 27.7832 10.1514 27.5399L55.9198 1.10938C56.063 1.35271 58.754 6.01186 59.4983 7.30726L13.7227 33.7378Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_3191_33572)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.4986 7.30719L13.7229 33.7377C13.6943 33.6876 13.6585 33.6303 13.6299 33.5731L59.4055 7.14258C59.4413 7.19983 59.4699 7.25709 59.4986 7.30719Z",
    fill: "#C09890"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4053 7.14275L13.6297 33.5732C13.5868 33.5017 13.5367 33.4158 13.4866 33.3299L59.2622 6.89941C59.3123 6.9853 59.3624 7.07118 59.4053 7.14275Z",
    fill: "#C39A92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2621 6.89859L13.4865 33.3291C13.4364 33.2432 13.3863 33.1573 13.3362 33.0643L59.1118 6.63379C59.1691 6.72683 59.2192 6.81271 59.2621 6.89859Z",
    fill: "#C69D94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1119 6.63491L13.3362 33.0654C13.2861 32.9724 13.2289 32.8793 13.1716 32.7791L58.9401 6.34863C58.9974 6.44883 59.0546 6.54903 59.1047 6.63491",
    fill: "#C99F96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9401 6.34811L13.1716 32.7786C13.1143 32.6784 13.0499 32.571 12.9927 32.4637L58.7612 6.0332C58.8256 6.14056 58.8828 6.24791 58.9401 6.34811Z",
    fill: "#CCA198"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7612 6.03331L12.9855 32.4638C12.9211 32.3493 12.8567 32.2348 12.7852 32.1203L58.5608 5.68262C58.6324 5.79713 58.6968 5.9188 58.7612 6.02615",
    fill: "#CEA49B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5607 5.68303L12.7851 32.1135C12.7135 31.9918 12.642 31.863 12.5632 31.7342L58.346 5.30371C58.4176 5.43254 58.4963 5.56136 58.5679 5.68303",
    fill: "#D1A69D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3461 5.30377L12.5705 31.7343C12.4918 31.5983 12.413 31.4551 12.3271 31.312L58.1028 4.88867C58.1815 5.03181 58.2674 5.16779 58.3461 5.31093",
    fill: "#D4A89F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1028 4.88837L12.3271 31.3189C12.2413 31.1614 12.1482 31.0111 12.0552 30.8537L57.8308 4.41602C57.9238 4.57347 58.0097 4.73092 58.1028 4.88122",
    fill: "#D7AAA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8309 4.41569L12.0552 30.8462C11.955 30.6744 11.8548 30.4955 11.7546 30.3237L57.5303 3.90039C57.6305 4.07216 57.7307 4.25108 57.8309 4.42285",
    fill: "#DAADA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5302 3.90066L11.7546 30.324C11.6401 30.1236 11.5256 29.9304 11.4182 29.7371L57.1867 3.30664C57.294 3.49988 57.4086 3.69311 57.5231 3.89351",
    fill: "#DDAFA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1866 3.30655L11.4181 29.737C11.2893 29.508 11.1605 29.2933 11.0388 29.0858L56.8144 2.65527C56.9361 2.86282 57.0578 3.08469 57.1938 3.30655",
    fill: "#E0B1A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8144 2.65514L11.0388 29.0856C10.8885 28.8208 10.7454 28.5847 10.6309 28.3699L56.3993 1.93945C56.521 2.147 56.657 2.39034 56.8144 2.65514Z",
    fill: "#E2B3AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3995 1.93969L10.631 28.3702C10.4664 28.0839 10.3304 27.8549 10.2517 27.7046L56.0202 1.28125C56.1061 1.42439 56.2349 1.66057 56.4067 1.94684",
    fill: "#E5B6AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0201 1.28114L10.2445 27.7045L10.1443 27.5327L55.9199 1.10938L56.0201 1.28114Z",
    fill: "#E8B8AE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_3191_33572",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 0,
    width: 5,
    height: 8
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0635 7.15692V0C61.4949 0 62.9262 0.37216 64.2145 1.10932C64.0713 1.35266 61.3875 6.01897 60.6432 7.30721C60.4643 7.19986 60.2639 7.14976 60.0635 7.14976V7.15692Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_3191_33572)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.0635 7.15692V0C61.4949 0 62.9262 0.37216 64.2145 1.10932C64.0713 1.35266 61.3875 6.01897 60.6432 7.30721C60.4643 7.19986 60.2639 7.14976 60.0635 7.14976",
    fill: "#FCC8BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6432 7.31437C60.4643 7.20701 60.2639 7.15692 60.0635 7.15692V0C61.3875 0 62.7115 0.314904 63.9211 0.95187C63.8996 0.966184 63.8638 0.980497 63.8423 0.994811C63.5704 1.28824 63.5417 1.50295 63.3986 2.52639C62.504 4.07229 61.137 6.44838 60.636 7.31437",
    fill: "#FCC8BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6432 7.31437C60.4643 7.20701 60.2639 7.15692 60.0635 7.15692V0C60.8579 0 61.6523 0.114511 62.4181 0.343532C62.4181 0.365003 62.4038 0.39363 62.4038 0.415101C62.3561 0.730005 62.4276 1.88704 62.6185 3.88621C61.8455 5.22455 61.0082 6.6774 60.6432 7.31437Z",
    fill: "#F9C5BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6432 7.31437C60.4643 7.20701 60.2639 7.15692 60.0635 7.15692V0C60.4428 0 60.815 0.0286277 61.1871 0.0787261C61.1871 0.100197 61.2014 0.135981 61.2086 0.157452L62.1819 4.63052C61.545 5.73269 60.9366 6.79191 60.636 7.31437",
    fill: "#F6C3B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6432 7.31437C60.4643 7.20701 60.2639 7.15692 60.0635 7.15692V0C60.0635 0 60.1207 0.0500984 60.1494 0.0715692C60.8579 1.25962 61.867 5.13867 61.8742 5.16729C61.3589 6.06191 60.8937 6.87064 60.6432 7.30721",
    fill: "#F4C1B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6432 7.31435C60.4643 7.20699 60.2639 7.15689 60.0635 7.15689V1.50293C60.0849 1.54587 60.1136 1.61028 60.135 1.65322C60.5645 2.44764 61.2945 4.42295 61.6308 5.58953C61.2086 6.31953 60.8436 6.94934 60.636 7.31435",
    fill: "#F1BFB4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6432 7.31473C60.4643 7.20738 60.2639 7.15728 60.0635 7.15728V2.62695C60.7291 3.82931 61.18 5.08177 61.4376 5.92629C61.1012 6.506 60.8149 7.00699 60.636 7.31473",
    fill: "#EEBCB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6432 7.31429C60.4643 7.20693 60.2639 7.15684 60.0635 7.15684V3.46387C60.0993 3.52112 60.1422 3.59269 60.178 3.64995C60.9438 5.13143 61.2157 5.9831 61.2802 6.21212C61.0153 6.67017 60.7935 7.0638 60.6432 7.32144",
    fill: "#EBBAB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6432 7.31438C60.4643 7.20702 60.2639 7.15692 60.0635 7.15692V4.11523C60.0849 4.15818 60.1207 4.20827 60.1494 4.25122C60.5072 4.78798 61.0297 6.10486 61.1442 6.44123C60.9366 6.79908 60.7649 7.09967 60.6432 7.30722",
    fill: "#E8B8AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6432 7.3144C60.4643 7.20704 60.2639 7.15694 60.0635 7.15694V4.65918C60.0635 4.65918 60.0849 4.68781 60.0921 4.70212C60.3712 5.11007 60.8006 6.04762 61.0225 6.65596C60.8722 6.92076 60.7434 7.14263 60.6432 7.3144Z",
    fill: "#E5B6AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6432 7.31371C60.4643 7.20635 60.2639 7.15625 60.0635 7.15625V5.10938C60.0635 5.10938 60.0706 5.12369 60.0778 5.13085C60.4786 5.71056 60.908 6.82704 60.908 6.84135C60.8006 7.02743 60.7076 7.18488 60.636 7.31371",
    fill: "#E2B3AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6432 7.31395C60.4643 7.2066 60.2639 7.1565 60.0635 7.1565V5.49609C60.0635 5.49609 60.0849 5.53188 60.0993 5.54619C60.407 5.98992 60.7792 6.89169 60.8221 6.99905C60.7577 7.11356 60.6933 7.22091 60.6432 7.30679",
    fill: "#E0B1A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6432 7.31449C60.4643 7.20714 60.2639 7.15704 60.0635 7.15704V5.83301C60.0635 5.83301 60.1064 5.89742 60.1207 5.91889C60.3712 6.34115 60.3784 6.35546 60.7362 7.13557C60.7004 7.19998 60.6647 7.25723 60.636 7.30733",
    fill: "#DDAFA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6432 7.31468C60.4643 7.20733 60.2639 7.15723 60.0635 7.15723V6.13379C60.0635 6.13379 60.0993 6.18389 60.1136 6.21252C60.1851 6.33418 60.2567 6.44869 60.3211 6.57036C60.4428 6.79938 60.543 7.03556 60.6647 7.26458C60.6575 7.2789 60.6432 7.30037 60.636 7.31468",
    fill: "#DAADA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0635 7.15707V6.39844C60.1207 6.47955 60.2806 6.76821 60.543 7.26442C60.3927 7.19286 60.2281 7.15707 60.0635 7.15707Z",
    fill: "#D7AAA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0635 7.15656V6.62695C60.1851 6.80588 60.2567 6.9347 60.407 7.20666C60.2925 7.17088 60.178 7.15656 60.0635 7.15656Z",
    fill: "#D4A89F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0635 7.15702V6.83496C60.0635 6.83496 60.0849 6.87075 60.0993 6.88506C60.1637 6.9781 60.2281 7.0783 60.2853 7.17849C60.2138 7.16418 60.1422 7.15702 60.0635 7.15702Z",
    fill: "#D1A69D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0635 7.15681V7.01367C60.0635 7.01367 60.0849 7.0423 60.0921 7.05661C60.1136 7.0924 60.1422 7.12818 60.1637 7.15681C60.1279 7.15681 60.0921 7.15681 60.0635 7.15681Z",
    fill: "#CEA49B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_3191_33572",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 0,
    width: 6,
    height: 8
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4981 7.30721C58.7538 6.01181 56.0628 1.35266 55.9197 1.10932C57.2008 0.365003 58.6321 0 60.0635 0V7.15692C59.8631 7.15692 59.6699 7.20701 59.4981 7.30721Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_3191_33572)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.4981 7.30721C58.7538 6.01181 56.0628 1.35266 55.9197 1.10932C57.2008 0.365003 58.6321 0 60.0635 0V7.15692C59.8631 7.15692 59.6699 7.20701 59.4981 7.30721Z",
    fill: "#F1BFB4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0635 7.15728C59.8631 7.15728 59.6699 7.20738 59.4981 7.30757C58.7538 6.01217 56.0628 1.35302 55.9197 1.10968C56.9073 0.53713 57.988 0.186442 59.0902 0.0576172C59.1188 0.0790879 59.1474 0.100559 59.1761 0.122029C59.5339 0.479875 59.856 1.09537 60.0635 1.50331V7.16443",
    fill: "#F1BFB4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0635 7.15673C59.8631 7.15673 59.6699 7.20683 59.4981 7.30703C58.7538 6.01162 56.0628 1.35247 55.9197 1.10914C56.6282 0.701193 57.3797 0.407759 58.1526 0.22168C58.1813 0.235994 58.2242 0.250307 58.2528 0.264621C58.7968 0.629624 59.3908 1.40257 60.0707 2.6264V7.15673",
    fill: "#EEBCB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0635 7.15657C59.8631 7.15657 59.6699 7.20667 59.4981 7.30687C58.7538 6.01147 56.0628 1.35231 55.9197 1.10898C56.3562 0.858488 56.8071 0.650937 57.2652 0.486328C57.301 0.493485 57.3511 0.507799 57.3868 0.514956C57.9809 0.722506 58.99 1.60996 60.0635 3.46361V7.16373",
    fill: "#EBBAB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0635 7.15647C59.8631 7.15647 59.6699 7.20657 59.4981 7.30677C58.7538 6.01136 56.0628 1.35221 55.9197 1.10888C56.0843 1.00868 56.2561 0.922797 56.4278 0.836914C56.4421 0.836914 56.4636 0.836914 56.4851 0.836914C57.9522 1.02299 59.6198 3.30605 60.0635 4.11478V7.15647Z",
    fill: "#E8B8AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0635 7.1574C59.8631 7.1574 59.6699 7.2075 59.4981 7.30769C58.8182 6.13396 56.528 2.16187 56.0127 1.27441C56.0199 1.27441 56.0342 1.27441 56.0413 1.27441C57.8377 1.56069 59.6413 3.87953 60.0635 4.64532V7.14309",
    fill: "#E5B6AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0635 7.15684C59.8631 7.15684 59.6699 7.20694 59.4981 7.30714C58.9327 6.32664 57.2365 3.39231 56.3992 1.93945C56.4707 1.96808 56.5638 1.99671 56.6353 2.02534C58.1669 2.64799 59.5625 4.20104 60.0707 5.10997V7.15684",
    fill: "#E2B3AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0635 7.15729C59.8631 7.15729 59.6699 7.20739 59.4981 7.30759C59.0115 6.46307 57.7017 4.19433 56.8071 2.64844C56.8787 2.67707 56.9646 2.72001 57.0361 2.74863C58.7824 3.64325 59.6842 4.85277 60.0635 5.48973V7.15014",
    fill: "#E0B1A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0636 7.15706C59.8632 7.15706 59.67 7.20716 59.4982 7.30736C59.076 6.57735 58.0382 4.78097 57.1865 3.30664C57.2509 3.33527 57.3368 3.37821 57.4012 3.40684C58.575 4.05812 59.4767 4.874 60.0636 5.83303V7.15706Z",
    fill: "#DDAFA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0636 7.15711C59.8632 7.15711 59.6699 7.20721 59.4982 7.3074C59.1332 6.67044 58.2958 5.2319 57.53 3.89355C58.8827 4.57346 59.6556 5.48239 60.0707 6.12651V7.15711",
    fill: "#DAADA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0635 7.15679C59.8631 7.15679 59.6699 7.20689 59.4981 7.30709C59.1832 6.75601 58.5105 5.58943 57.8306 4.42285C57.8807 4.45148 57.9522 4.48011 58.0023 4.50873C58.3888 4.7306 59.3049 5.25305 60.0635 6.391V7.15679Z",
    fill: "#D7AAA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0635 7.15644C59.8631 7.15644 59.6699 7.20654 59.4981 7.30673C59.219 6.82722 58.6822 5.88966 58.1025 4.8877C58.1526 4.90917 58.2099 4.94495 58.26 4.96642C58.6107 5.17397 59.4337 5.65349 60.0707 6.62683V7.15644",
    fill: "#D4A89F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0634 7.15735C59.863 7.15735 59.6698 7.20745 59.498 7.30765C59.2619 6.8997 58.8253 6.14823 58.3386 5.30371C59.269 5.79038 59.77 6.40588 60.0634 6.82813V7.15735Z",
    fill: "#D1A69D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0635 7.15694C59.8631 7.15694 59.6699 7.20704 59.4981 7.30724C59.2977 6.95655 58.9542 6.36968 58.5605 5.68262C59.3263 6.09056 59.7343 6.56292 60.0635 7.00665V7.14978",
    fill: "#CEA49B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4981 7.30746C59.3335 7.02118 59.0687 6.56314 58.761 6.02637C59.4123 6.38421 59.7415 6.76353 60.0564 7.15716C59.8631 7.15716 59.6699 7.20726 59.4981 7.30746Z",
    fill: "#CCA198"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4982 7.307C59.3622 7.07798 59.169 6.74161 58.9399 6.34082C58.9686 6.35513 59.0044 6.3766 59.033 6.39808C59.398 6.61994 59.6198 6.80602 59.9348 7.16387C59.7773 7.17818 59.6342 7.22828 59.491 7.307",
    fill: "#C99F96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4981 7.30654C59.3979 7.13477 59.2619 6.90575 59.1045 6.63379C59.126 6.6481 59.1617 6.66957 59.1832 6.68389C59.4337 6.83418 59.5912 6.96301 59.8202 7.18487C59.7057 7.20634 59.5912 7.24928 59.491 7.3137",
    fill: "#C69D94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4981 7.30736C59.4337 7.19285 59.355 7.05687 59.262 6.89941C59.2834 6.91373 59.3121 6.92804 59.3335 6.94236C59.448 7.01392 59.5339 7.06402 59.72 7.21432C59.6484 7.23579 59.5697 7.27157 59.5053 7.31452",
    fill: "#C39A92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4981 7.30719C59.4695 7.25709 59.4337 7.19983 59.3979 7.14258C59.4123 7.14974 59.4409 7.16405 59.4552 7.17836C59.5053 7.20699 59.5482 7.23562 59.5912 7.25709C59.5554 7.2714 59.5268 7.29287 59.491 7.30719",
    fill: "#C09890"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0636 7.15723C60.264 7.15723 60.4573 7.20733 60.6434 7.31468C75.8947 16.1248 91.1533 24.9278 106.412 33.738C106.77 33.9456 106.977 34.3106 106.984 34.7185V87.5723C106.984 87.9803 106.77 88.3453 106.419 88.5528C91.1604 97.363 75.9019 106.173 60.6434 114.983C60.4644 115.084 60.2712 115.134 60.0708 115.134C59.8704 115.134 59.6772 115.084 59.5054 114.983C44.2469 106.173 28.9883 97.363 13.7298 88.5528C13.3719 88.3453 13.1644 87.9803 13.1572 87.5723V34.7185C13.1572 34.3106 13.3719 33.9456 13.7226 33.738C28.9812 24.9278 44.2397 16.1177 59.4983 7.30752C59.6772 7.20733 59.8633 7.15723 60.0636 7.15723Z",
    fill: "#ECBBB1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M115.327 103.424H4.67371C2.09263 103.424 0.000244141 105.516 0.000244141 108.097V126.741C0.000244141 129.322 2.09263 131.415 4.67371 131.415H115.327C117.908 131.415 120 129.322 120 126.741V108.097C120 105.516 117.908 103.424 115.327 103.424Z",
    fill: "#192227"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3967 121.931L30.2165 125.881L24.1475 122.632L24.1689 120.206L27.3967 121.931Z",
    fill: "#BC934E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1689 120.206L24.1474 122.632L18.0354 125.788L20.9196 121.881L24.1689 120.206Z",
    fill: "#CEA256"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8027 118.324L29.1001 119.097L30.2166 125.882L27.3968 121.931L26.8027 118.324Z",
    fill: "#F8C267"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9196 121.881L18.0354 125.789L19.2521 119.018L21.5709 118.288L20.9196 121.881Z",
    fill: "#C39951"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4436 115.791L34.067 114.331L29.1001 119.098L26.8027 118.325L29.4436 115.791Z",
    fill: "#D7A95A"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M21.571 118.288L19.2522 119.018L14.364 114.173L18.9659 115.712L21.571 118.288Z",
    fill: "#BB924E"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8296 115.233L27.2681 113.286L34.0672 114.331L29.4438 115.791L25.8296 115.233Z",
    fill: "#F3BF65"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9659 115.712L14.364 114.173L21.1774 113.235L22.5945 115.211L18.9659 115.712Z",
    fill: "#EAB761"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5946 115.211L21.1775 113.235L24.2693 107.095L24.2335 111.947L22.5946 115.211Z",
    fill: "#C99E54"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2336 111.947L25.8295 115.232L29.4438 115.791L26.8029 118.324L27.3969 121.931L24.1691 120.206L20.9199 121.881L21.5712 118.288L18.9661 115.712L22.5946 115.211L24.2336 111.947Z",
    fill: "#E9B761"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2334 111.947L24.2692 107.095L27.2679 113.285L25.8294 115.232L24.2334 111.947Z",
    fill: "#FDC669"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1813 121.931L66.0011 125.881L59.9392 122.632L59.9607 120.206L63.1813 121.931Z",
    fill: "#BC934E"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9607 120.206L59.9392 122.632L53.8201 125.788L56.7043 121.881L59.9607 120.206Z",
    fill: "#CEA256"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5872 118.324L64.8917 119.097L66.001 125.882L63.1812 121.931L62.5872 118.324Z",
    fill: "#F8C267"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7043 121.881L53.8201 125.789L55.0367 119.018L57.3484 118.288L56.7043 121.881Z",
    fill: "#C39951"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2352 115.791L69.8586 114.331L64.8917 119.098L62.5872 118.325L65.2352 115.791Z",
    fill: "#D7A95A"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3485 118.288L55.0369 119.018L50.1487 114.173L54.7506 115.712L57.3485 118.288Z",
    fill: "#BB924E"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M61.614 115.233L63.0526 113.286L69.8588 114.331L65.2354 115.791L61.614 115.233Z",
    fill: "#F3BF65"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7506 115.712L50.1487 114.173L56.9621 113.235L58.372 115.211L54.7506 115.712Z",
    fill: "#EAB761"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3718 115.211L56.9619 113.235L60.0609 107.095L60.0179 111.94L58.3718 115.211Z",
    fill: "#C99E54"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M60.018 111.939L61.614 115.232L65.2354 115.79L62.5873 118.323L63.1813 121.931L59.9607 120.206L56.7043 121.88L57.3484 118.288L54.7505 115.711L58.3719 115.21L60.018 111.939Z",
    fill: "#E9B761"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0181 111.94L60.061 107.095L63.0526 113.285L61.6141 115.232L60.0181 111.94Z",
    fill: "#FDC669"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9658 121.938L101.786 125.881L95.7166 122.632L95.738 120.206L98.9658 121.938Z",
    fill: "#BC934E"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M95.738 120.206L95.7165 122.632L89.6045 125.788L92.4887 121.881L95.738 120.206Z",
    fill: "#CEA256"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3789 118.324L100.676 119.097L101.786 125.882L98.9658 121.938L98.3789 118.324Z",
    fill: "#F8C267"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4887 121.881L89.6045 125.789L90.8212 119.018L93.1329 118.288L92.4887 121.881Z",
    fill: "#C39951"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M101.02 115.791L105.636 114.331L100.676 119.098L98.3789 118.325L101.02 115.791Z",
    fill: "#D7A95A"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M93.133 118.288L90.8213 119.018L85.9331 114.173L90.535 115.712L93.133 118.288Z",
    fill: "#BB924E"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3987 115.233L98.8372 113.286L105.636 114.331L101.02 115.791L97.3987 115.233Z",
    fill: "#F3BF65"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M90.535 115.712L85.9331 114.173L92.7465 113.235L94.1564 115.211L90.535 115.712Z",
    fill: "#EAB761"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1565 115.211L92.7466 113.235L95.8384 107.095L95.8026 111.947L94.1565 115.211Z",
    fill: "#C99E54"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8026 111.947L97.3986 115.232L101.02 115.791L98.3791 118.324L98.966 121.938L95.7382 120.206L92.489 121.881L93.1331 118.288L90.5352 115.712L94.1566 115.211L95.8026 111.947Z",
    fill: "#E9B761"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8025 111.947L95.8383 107.095L98.837 113.285L97.3985 115.232L95.8025 111.947Z",
    fill: "#FDC669"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7502 41.875L45.3995 43.2258C44.1807 44.4445 43.5002 46.0898 43.5002 47.8164V61.2633C43.5002 62.35 44.0385 63.3656 44.9424 63.9648L46.019 64.6758C47.4713 65.6508 49.3401 65.7625 50.9042 64.9805L51.2292 64.818C51.4932 64.6859 51.737 64.5336 51.9706 64.3609L56.9877 60.6031C57.6581 60.0953 58.5823 60.0953 59.2526 60.6031C60.2885 61.3852 60.2581 62.9492 59.1815 63.6805L46.1815 72.5469C44.5057 73.6945 43.5002 75.5938 43.5002 77.625H76.0002L78.9354 61.4766C79.1487 60.3289 79.2502 59.1609 79.2502 57.993V56.5C79.2502 45.7344 70.5159 37 59.7502 37H45.5112C44.4042 37 43.5002 37.9039 43.5002 39.0109C43.5002 39.7727 43.9268 40.4633 44.6073 40.8086L46.7502 41.875ZM49.1877 48.7812C49.1877 48.2425 49.4018 47.7259 49.7827 47.3449C50.1636 46.964 50.6803 46.75 51.219 46.75C51.7577 46.75 52.2744 46.964 52.6553 47.3449C53.0362 47.7259 53.2502 48.2425 53.2502 48.7812C53.2502 49.32 53.0362 49.8366 52.6553 50.2176C52.2744 50.5985 51.7577 50.8125 51.219 50.8125C50.6803 50.8125 50.1636 50.5985 49.7827 50.2176C49.4018 49.8366 49.1877 49.32 49.1877 48.7812ZM39.2956 85.0797C38.869 85.5062 38.6252 86.0953 38.6252 86.7047C38.6252 87.9742 39.651 89 40.9206 89H78.5799C79.8495 89 80.8752 87.9742 80.8752 86.7047C80.8752 86.0953 80.6315 85.5062 80.2049 85.0797L76.0002 80.875H43.5002L39.2956 85.0797Z",
    fill: "#CC4A2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsolidadoTres);
export default __webpack_public_path__ + "static/media/consolidadoTres.864f461e69dff1d86998681efe6d3a2b.svg";
export { ForwardRef as ReactComponent };